import { Component, ComponentFactoryResolver, OnInit, ViewChild, ViewContainerRef, inject } from '@angular/core';
import { WestnetzSidenavService } from '../../../service/common/westnetz-sidenav/westnetz-sidenav.service';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../../service/auth/authentication.service';
import { UflaUser } from '../../../service/auth/ufla-user';
import { MatSidenav } from '@angular/material/sidenav';

@Component({
    selector: 'ufla-westnetz-page',
    templateUrl: './westnetz-page.component.html',
    styleUrls: [
        './westnetz-page.component.scss',
    ],
    standalone: false,
})
export class WestnetzPageComponent implements OnInit {
    authenticationService = inject(AuthenticationService);
    router = inject(Router);
    private westnetzSidenavService = inject(WestnetzSidenavService);
    private componentFactoryResolver = inject(ComponentFactoryResolver);

    public profile: UflaUser = null;

  @ViewChild('right', { static: true }) right: MatSidenav;
  @ViewChild('rightTemplate', { read: ViewContainerRef, static: true }) rightTemplateContainer: ViewContainerRef;

  constructor() {
      const westnetzSidenavService = this.westnetzSidenavService;

      westnetzSidenavService.openRightNav$.subscribe(component => {
          const factory = this.componentFactoryResolver.resolveComponentFactory(component);

          this.rightTemplateContainer.clear();
          this.rightTemplateContainer.createComponent(factory);

          this.right.open();
      });

      westnetzSidenavService.closeRightNav$.subscribe(() => this.right.close());
  }

  async ngOnInit() {
      this.authenticationService.user$
          .subscribe(async (user) => {
              this.profile = user;
          });
  }

  public login() {
      this.authenticationService.login();
  }

}
